import { defineComponent as _defineComponent } from 'vue'
import type { SportType } from '@/@types/graphql-types';
import type { Locale } from '@/helpers/locale-helper';

import { SingleStepContext } from '@/features/sports/helpers/config';
import { displayTimeZone } from '@/helpers/time-zone-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SportPageType } from '@/features/sports/types/interfaces';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeZoneSwitcher',
  props: {
    context: null
  },
  setup(__props: any) {

const props = __props as { context: SingleStepContext };

const languageStore = useLanguageStore();
const userStore = useUserStore();



const visible = ref(false);

const browserTimeZone = computed(() => Intl.DateTimeFormat().resolvedOptions().timeZone);

const currentLocale = computed(() =>
	(languageStore.locales.value as Locale[]).find(locale => locale.webLocale === languageStore.webLocale.value)
);

const localeDefaultAndBrowserMismatch = computed(() => currentLocale.value?.timezone != browserTimeZone.value);

const sportContexts = computed(() => {
	const sportType =
		(props.context.pageType as SportPageType) === SportPageType.AllSports
			? SportPageType.Generic
			: props.context.sportType;

	return [new SnowplowSportContext(sportType as SportType, props.context.pageType)];
});

const currentTimeZone = computed(() => {
	return displayTimeZone(
		languageStore.locales.value,
		languageStore.webLocale.value,
		userStore.timeZone.value
	)?.replaceAll('_', ' ');
});

function changeTimeZone() {
	userStore.setTimeZone(browserTimeZone.value);
	visible.value = false;
	TrackingHelper.trackEvent('userinteraction', { action: 'timezone_switcher_click' }, sportContexts.value);
}

const isMounted = ref(false);
onMounted(() => {
	visible.value = localeDefaultAndBrowserMismatch.value && userStore.timeZone.value === false;
	if (!isMounted.value && visible.value) {
		TrackingHelper.trackEvent('timezone_switcher', { action: 'impression' }, sportContexts.value);
		isMounted.value = true;
	}
});

return { __sfc: true,languageStore, userStore, props, visible, browserTimeZone, currentLocale, localeDefaultAndBrowserMismatch, sportContexts, currentTimeZone, changeTimeZone, isMounted }
}

})